import {
	Box,
	Circle,
	Flex,
	Heading,
	Stack,
	Text,
	Button,
	Image,
	Divider,
	useMediaQuery,
	useBreakpointValue,
	VStack,
	Stepper,
	Step,
	StepIndicator,
	StepStatus,
	StepIcon,
	StepNumber,
	StepTitle,
	StepDescription,
	StepSeparator,
	useSteps,
	Progress,
	useToast,
	Skeleton,
} from '@chakra-ui/react';
import Resume from '../../assets/images/Resume.svg';
import React, { useEffect } from 'react';
import { useMutation } from 'react-query';
import { createResume } from '../../../apis/V2/resume';
import { AxiosError } from 'axios';
import { UIErrorResponse } from 'types/src/error';
import { useResumes, useUserProfile } from '../../../hooks/V2/useUser';
import OldUserResume from './OldUserResume';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

export const CreateResume = () => {
	const { data: domainConfig, isLoading, isError } = useDomainConfig({ uiHost: window.location.host });

	const { data: resumes } = useResumes();
	const [isLargerThan860] = useMediaQuery('(min-width: 860px)');
	const steps = [
		{ title: 'Build Profile', description: 'Share your personal & educational details.' },
		{
			title: 'Select Role',
			description: 'Choose a domain you want to build your career in.',
		},
		{
			title: 'Generate Resume',
			description: 'Create your resume based on the details provided.',
		},
	];

	const toast = useToast();

	const { data: userProfile, refetch: refetchUserProfile, isFetched, isSuccess } = useUserProfile();

	useEffect(() => {
		console.log('userProfile---:', userProfile);
	}, [userProfile]);

	const { mutate: createResumeMutate, isLoading: createResumeMutateLoading } = useMutation(createResume, {
		onSuccess: resumeBuilderData => {
			const resume_builder_url = resumeBuilderData?.data?.resume_builder_url;
			refetchUserProfile();
			window.location.href = resume_builder_url;
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Creating resume failed!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	if (!isFetched) return <Skeleton h="100vh">Loading...</Skeleton>;

	return (
		<Box minH="full" pb={{ base: '100px', md: '50px' }} bg={'#F2F6FF'}>
			<Box h="full" position="relative" p="16px" bg={'#F2F6FF'}>
				{domainConfig?.key === 'masai' && userProfile?.resumeBuilderUserId && resumes && resumes?.length > 0 ? (
					<Box>
						<OldUserResume />
					</Box>
				) : (
					<Box>
						<Box w="full" m={'auto'} mb="20px">
							<Heading as={'h6'} textStyle={['h6', 'h6', 'h4', 'h4']}>
								Steps to create your resume.
							</Heading>
						</Box>
						{isLargerThan860 ? (
							<>
								<Box
									borderRadius={{ base: '12px', md: '32px' }}
									overflow={'hidden'}
									bg="white"
									mt="20px"
									boxShadow={'base'}
									position="relative"
									m={'auto'}
									w="full"
								>
									<Box
										position={'absolute'}
										right={'0px'}
										w={'90px'}
										h={'90px'}
										bg="#F5F0FF"
										borderTopRightRadius={'12px'}
										borderBottomLeftRadius="70px"
										display="flex"
										alignItems="center"
										justifyContent="center"
									>
										<Image src={Resume} alt="" width="45px" height={'45px'} />
									</Box>

									<Box p="32px" maxW="100%">
										<Stepper index={3} colorScheme="purple" gap="0px" alignItems="start !important">
											{steps.map((step, index) => (
												<Step key={index} style={{ flex: '1', width: 'auto', gap: '24px', flexDirection: 'column', alignItems: 'start' }}>
													<Box position="relative" w="full" display="flex" alignItems="center" sx={{ '--stepper-indicator-size': '24px' }}>
														<StepIndicator boxSize="37px">
															<StepStatus complete={<StepNumber />} incomplete={<StepNumber />} active={<StepNumber />} />
														</StepIndicator>
														{/*******************  Dashed Border *******************/}
														<Box
															w="1px"
															m="0px !important"
															as={StepSeparator}
															top="var(--stepper-indicator-size) !important"
															maxH="calc(100% - var(--stepper-indicator-size)) !important"
														/>
													</Box>

													<Box flexShrink="0" pr={{ md: '8px', lg: '75px' }}>
														<Text textStyle="h3">{step.title}</Text>
														<Text mt="8px" textStyle="body1-md" color="#544D4F">
															{step.description}
														</Text>
													</Box>
												</Step>
											))}
										</Stepper>
									</Box>

									<Box display="flex" justifyContent="center" p="5" w={'30%'} m={'auto'}>
										<Button
											size={'block-md'}
											borderRadius={'8px'}
											variant={'primary'}
											fontSize="btn-lg"
											p={'6'}
											bg={'#4358F6'}
											as={'a'}
											cursor="pointer"
											isLoading={createResumeMutateLoading}
											onClick={() => {
												if (domainConfig?.key !== 'masai') {
													return;
												}
												//create resume
												createResumeMutate();
											}}
										>
											{/* COMING SOON */}
											{domainConfig?.key !== 'masai' ? 'COMING SOON' : 'START NOW'}
										</Button>
									</Box>
								</Box>
								{/* <Stepper index={activeStep} orientation="horizontal" w={'70%'} m={'auto'}
				
					  gap="0">
						{steps.map((step, index) => (
							<Step key={index}>
								<StepIndicator
									bg={index === activeStep ? '#7261DF' : '#FFFFFF'} // Change the active and inactive background colors here
									border={'1.6px solid'}
									stroke={'#CFD0EE'}
									color={'white'}
								>
									<StepStatus complete={<StepNumber />} incomplete={<StepNumber />} active={<StepNumber />} />
								</StepIndicator>

								<Box flexShrink="0"
								 mt={'32'} 
								 w={'200px'}
								 position={'absolute'}>
									<StepTitle>{step.title}</StepTitle>
									<StepDescription>{step.description}</StepDescription>
								</Box>

								{index !== steps.length - 1 && <StepSeparator />}
							</Step>
						))}
					</Stepper> */}
							</>
						) : (
							// Mobile View
							<Box position="relative" borderRadius={'12px'} overflow={'hidden'} bg="white" mt="20px" boxShadow={'base'}>
								<Box
									position={'absolute'}
									right={'0px'}
									w={'90px'}
									h={'90px'}
									bg="#F5F0FF"
									borderTopRightRadius={'12px'}
									borderBottomLeftRadius="70px"
									pl={'30px'}
									pt={'15px'}
								>
									<Image src={Resume} alt="" width="45px" height={'45px'} />
								</Box>

								<Box p="32px 12px 0px 12px">
									<Stepper index={3} colorScheme="purple" orientation="vertical" height="290px" gap="0">
										{steps.map((step, index) => (
											<Step key={index} style={{ gap: '24px' }}>
												<Box position="relative" sx={{ '--stepper-indicator-size': '24px' }}>
													<StepIndicator boxSize="24px">
														<StepStatus complete={<StepNumber />} incomplete={<StepNumber />} active={<StepNumber />} />
													</StepIndicator>
													{/*******************  Dashed Border *******************/}
													<Box
														w="1px"
														m="0px !important"
														as={StepSeparator}
														top="var(--stepper-indicator-size) !important"
														maxH="calc(100% - var(--stepper-indicator-size)) !important"
													/>
												</Box>

												<Box pr={{ md: '8px', lg: '75px' }}>
													<Text textStyle="h5">{step.title}</Text>
													<Text mt="8px" textStyle="body2" color="#544D4F">
														{step.description}
													</Text>
												</Box>
											</Step>
										))}
									</Stepper>
								</Box>

								<Box p="24px 12px">
									<Button
										size={'block-md'}
										borderRadius={'8px'}
										variant={'primary'}
										fontSize="btn-lg"
										p={'6'}
										bg={'#4358F6'}
										as={'a'}
										cursor="pointer"
										isLoading={createResumeMutateLoading}
										onClick={() => {
											if (domainConfig?.key !== 'masai') {
												return;
											}
											//create resume
											createResumeMutate();
										}}
									>
										{domainConfig?.key !== 'masai' ? 'COMING SOON' : 'START NOW'}
									</Button>
								</Box>
							</Box>
						)}
					</Box>
				)}
			</Box>
			{domainConfig?.key === 'masai' && userProfile?.resumeBuilderUserId && resumes && resumes?.length > 0 ? (
				<Box
					h="72px"
					width={'100%'}
					textAlign="center"
					px="16px"
					py="12px"
					bgColor={{ base: '#fff', md: '#F2F6FF' }}
					boxShadow={{ base: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', md: 'none' }}
					position={{ base: 'fixed', md: 'relative' }}
					bottom={{ base: '0px', md: 'auto' }}
				>
					<Button
						variant={'primary'}
						width={{ base: '100%', md: 'auto' }}
						size={'lg'}
						bgColor={'#4358F6'}
						textStyle={'btn-lg'}
						onClick={() => {
							if (domainConfig?.key !== 'masai') {
								return;
							}
							//create resume
							createResumeMutate();
						}}
						isLoading={createResumeMutateLoading}
					>
						{domainConfig?.key !== 'masai' ? 'COMING SOON' : 'Create New Resume'}
						<Image boxSize={'24px'} ml="8px" src="https://masai-website-images.s3.ap-south-1.amazonaws.com/add_circle_outline_9d093e3408.svg" />
					</Button>
				</Box>
			) : (
				<></>
			)}
		</Box>
	);
};
export default CreateResume;
